import React from 'react';
import i18n from '@i18n';
import clsx from 'clsx';
import useExpander from '@/_hooks/useExpander';
import { AccordionArrow } from '@/common/components/Accordion';

function BettingInfo({ expanded: initialExpanded }) {
    const [expanded, onToggle] = useExpander(initialExpanded);
    return (
        <div data-atid="accordion-betsInfo" className={clsx('accordion live-bets-info', { active: expanded })}>
            <h1 className="accordion-head flex items-center" onClick={onToggle}>
                <span>{i18n('accordion.title.betsInfo')}</span>
                <AccordionArrow expanded={expanded} />
            </h1>
            {expanded ? (
                <div className="accordion-content">
                    <p>{i18n('accordion.message.betsInfo2')}</p>
                </div>
            ) : null}
        </div>
    );
}

export default BettingInfo;
